import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const streamUrl = (url) => `${API}/stream?url=${encodeURIComponent(url)}`;

export const api = axios.create({ baseURL: API });

// Attach the right token per request (user vs admin).
// Attach the right token per request. Admin endpoints use the admin token; user
// endpoints prefer the user token but fall back to the admin token so an admin can
// browse the user-facing app in preview mode.
api.interceptors.request.use((config) => {
  const isAdminUrl = (config.url || "").startsWith("/admin");
  const userToken = localStorage.getItem("tvverse_token");
  const adminToken = localStorage.getItem("tvverse_admin_token");
  const token = isAdminUrl ? adminToken : userToken || adminToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return formatApiError(e?.response?.data?.detail) || e?.message || "Network error";
}
